//src/services/adminDiscounts.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminDiscounts = () => {
  return adminApiRequest("/admin/discounts");
};

export const getAdminDiscountById = (id) => {
  return adminApiRequest(`/admin/discounts/${id}`);
};

export const updateAdminDiscount = (id, data) => {
  return adminApiRequest(`/admin/discounts/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteAdminDiscount = (id) => {
  return adminApiRequest(`/admin/discounts/${id}`, {
    method: "DELETE",
  });
};